export default __webpack_public_path__ + "static/media/edge-coursely-serrate.89676c77.PNG";